/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Formik} from 'formik'
import Tab1 from './Tab1'
import Tab2 from './Tab2'
import Tab3 from './Tab3'
import Tab4 from './Tab4'

import {useLocation, useNavigate} from 'react-router-dom'
import api from '../../../_metronic/helpers/api'
import axios from 'axios'
import {useDispatch, useSelector} from 'react-redux'
import useUtils from './useUtils'
import {showAlert} from '../../redux/reducers/alertSlice'
import {setTitle} from '../../redux/reducers/mainSlice'
import AssignConfirmation from '../../modules/alert/AssignConfirmation'

const AddProgram = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [loader, setLoader] = useState(false)
  dispatch(setTitle('Program'))

  const location = useLocation()
  const locationState = location?.state?.result || null

  const {fetchCategories, fetchCohorts, fetchLanguages, fetchCourses, uploadImage, fetchSeasons} =
    useUtils()

  const languageOptions = useSelector((state) => state?.language?.records)
  const categoryOptions = useSelector((state) => state?.category?.records)

  const [tab, setTab] = useState(1)

  const programSchema = Yup.object().shape({
    code: Yup.string()
      .matches(/^[a-zA-Z0-9-_]+$/, 'Code should only be alpha numeric')
      .required('Please enter program code'),
    title: Yup.string().required('Please enter program title'),
    authorName: Yup.string().required('Please enter author name'),
    languageId: Yup.string().required('Please select language'),
    categoryId: Yup.string().required('Please select category'),
    cohortIds: Yup.array()
      .min(1, 'Please select at least one cohort')
      .required('Please select at least one cohort'),
    bannerImage: Yup.mixed().when('bannerImgUrl', {
      is: (bannerImgUrl) => !bannerImgUrl,
      then: Yup.mixed().required('Banner image is required'),
    }),
    squareImage: Yup.mixed().when('squareImgUrl', {
      is: (squareImgUrl) => !squareImgUrl,
      then: Yup.mixed().required('Square image is required'),
    }),
    shortDescription: Yup.string().required('Please enter short description'),
    longDescription: Yup.string().required('Please enter long description'),
    courseIds: Yup.array()
      .min(1, 'Please select at least 1 course')
      .required('Please select at least 1 course'),
    tags: Yup.array().min(1, 'Tags are mandatory').required('Tags are mandatory'),
    learningPoints: Yup.array()
      .min(1, 'Learning points are mandatory')
      .required('Learning points are mandatory'),
    seasonId: Yup.string().required('Please select Season'),
  })

  const initialValues = locationState
    ? {
        id: locationState?.id,
        isEdit: true,
        isClone: locationState?.id ? false : true,
        code: locationState?.code || '',
        title: locationState?.title || '',
        authorName: locationState?.authorName || '',
        shortDescription: locationState?.shortDescription || '',
        longDescription: locationState?.longDescription || '',
        tags: locationState?.tag.map((tags) => tags.name) || [],
        learningPoints: locationState?.learningPoint?.map((lps) => lps.name),
        status: locationState?.status || null,
        courseIds: locationState?.programCourse?.map((mu) => mu?.course?.id).filter(Boolean) || [],
        courses: locationState?.programCourse?.map((mu) => mu?.course?.title).filter(Boolean) || [],
        cohortIds: locationState?.programCohort?.map((pc) => pc.cohort?.id).filter(Boolean) || [],
        cohorts:
          locationState?.programCohort
            ?.map((pc) => pc.cohort?.title)
            .filter(Boolean)
            .join(', ') || '',
        seasonId: locationState?.seasonId ?? '',
        season: locationState?.seasonId ?? '',
        language: locationState?.language?.name ?? (languageOptions[0]?.name || ''),
        languageId: locationState?.languageId ?? (languageOptions[0]?.id || ''),
        category: locationState?.category?.name ?? (categoryOptions[0]?.name || ''),
        categoryId: locationState?.categoryId ?? (categoryOptions[0]?.id || ''),
        bannerImage: null,
        squareImage: null,
        bannerImgUrl: locationState?.bannerImageUrl || null,
        squareImgUrl: locationState?.squareImageUrl || null,
        bannerMediaId: locationState?.bannerMediaId || null,
        squareMediaId: locationState?.squareMediaId || null,
        isFeatured: locationState?.isFeatured || false,
        isForBlackforceMember: locationState?.isForBlackforceMember || false,
      }
    : {
        code: '',
        title: '',
        authorName: '',
        shortDescription: '',
        longDescription: '',
        tags: [],
        status: null,
        courseIds: [],
        courses: [],
        learningPoints: [],
        cohorts: '',
        cohortIds: [],
        language: '',
        languageId: '',
        category: '',
        categoryId: '',
        seasonId: '',
        season: '',
        bannerImage: '',
        squareImage: '',
        isFeatured: false,
        isForBlackforceMember: false,
      }

  useEffect(() => {
    fetchLanguages()
    fetchCohorts()
    fetchCategories()
    fetchSeasons()
  }, [])

  const updateProgram = async (values, bannerMediaId, squareMediaId) => {
    try {
      setLoader(true)
      let data = {
        id: values.id,
        code: values.code,
        title: values.title,
        authorName: values.authorName,
        cohortId: values.cohortId,
        languageId: values.languageId,
        categoryId: values.categoryId,
        isFeatured: values.isFeatured,
        isForBlackforceMember: values.isForBlackforceMember, //
        seasonId: values.seasonId, //
        bannerMediaId,
        squareMediaId,
        shortDescription: values.shortDescription,
        longDescription: values.longDescription,
        courseIds: values.courseIds,
        tags: values.tags,
        learningPoints: values.learningPoints,
      }
      const response = await api.patch(`program/${values.id}`, data)
      if (response?.data?.status) {
        console.log(response?.data?.data.id)
        values = {...values, id: data.id, status: values.status}
        dispatch(showAlert({message: 'Program Updated', variant: 'success'}))
        navigate('/programlist/preview-program', {state: {values}})
      }
    } catch (error) {
      console.log('error')
    } finally {
      setLoader(false)
    }
  }

  const handleSubmit = async (values) => {
    if (values.isEdit && !values.isClone) {
      // Check if we have existing media IDs (no new images to upload)
      if (values.bannerMediaId && values.squareMediaId) {
        try {
          setLoader(true)
          let data = {
            code: values.code,
            id: values.id,
            title: values.title,
            authorName: values.authorName,
            cohortIds: values.cohortIds,
            languageId: values.languageId,
            categoryId: values.categoryId,
            isFeatured: values.isFeatured,
            isForBlackforceMember: values.isForBlackforceMember,
            seasonId: values.seasonId,
            shortDescription: values.shortDescription,
            longDescription: values.longDescription,
            courseIds: values.courseIds,
            tags: values.tags,
            learningPoints: values.learningPoints,
          }
          const response = await api.patch(`program/${values.id}`, data)

          if (response.data.status) {
            dispatch(showAlert({message: 'Program updated', variant: 'success'}))
            navigate('/programlist/preview-program', {
              state: {values: {...values, status: values.status}},
            })
          }
        } catch (error) {
          dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
        } finally {
          setLoader(false)
        }
      } else {
        // Need to upload new images
        try {
          let bannerMediaId = values.bannerMediaId
          let squareMediaId = values.squareMediaId

          // Upload banner image if it's new
          if (values.bannerImage && !values.bannerMediaId) {
            const uniqueFileName = `banner_${Date.now()}`
            const imageFile = values.bannerImage
            const fileType = imageFile.type
            const fileSize = `${imageFile.size}`

            const uploadDetails = {
              fileName: uniqueFileName,
              fileType: fileType,
              size: fileSize,
            }

            const uploadResponse = await api.post('s3/upload-url', uploadDetails)
            const {mediaId, signedUrl} = uploadResponse.data.data

            const imageUploadResponse = await axios.put(signedUrl, imageFile, {
              headers: {
                'Content-Type': fileType,
              },
            })
            if (imageUploadResponse.status !== 200) {
              throw new Error('Banner image upload failed')
            }
            bannerMediaId = mediaId
          }

          // Upload square image if it's new
          if (values.squareImage && !values.squareMediaId) {
            const uniqueFileName = `square_${Date.now()}`
            const imageFile = values.squareImage
            const fileType = imageFile.type
            const fileSize = `${imageFile.size}`

            const uploadDetails = {
              fileName: uniqueFileName,
              fileType: fileType,
              size: fileSize,
            }

            const uploadResponse = await api.post('s3/upload-url', uploadDetails)
            const {mediaId, signedUrl} = uploadResponse.data.data

            const imageUploadResponse = await axios.put(signedUrl, imageFile, {
              headers: {
                'Content-Type': fileType,
              },
            })
            if (imageUploadResponse.status !== 200) {
              throw new Error('Square image upload failed')
            }
            squareMediaId = mediaId
          }

          updateProgram(values, bannerMediaId, squareMediaId)
        } catch (error) {
          console.log('Error uploading images:', error, error.message)
        }
      }
    } else {
      uploadImage(values)
    }
  }

  const getTabFields = (tab) => {
    switch (tab) {
      case 1:
        return [
          'code',
          'title',
          'authorName',
          'languageId',
          'categoryId',
          'cohortIds',
          'isForBlackforceMember',
          'seasonId',
          'bannerImage',
          'squareImage',
          'shortDescription',
          'longDescription',
        ]
      case 2:
        return ['courseIds']
      case 3:
        return ['tags', 'learningPoints']
      default:
        return []
    }
  }

  const handleTab = async (validateField, errors, setTouched, validateForm, num) => {
    if (num < tab) {
      setTab(num)
    } else if (num - tab === 1) {
      const tabFields = getTabFields(tab)
      const validationErrors = await validateForm()
      const errorsInTab = Object.keys(validationErrors).filter((field) => tabFields.includes(field))
      if (errorsInTab.length === 0) {
        setTab(num)
      } else {
        setTouched(
          tabFields.reduce((acc, field) => {
            acc[field] = true
            return acc
          }, {})
        )
      }
    }
  }

  const handleNextTab = async (validateField, errors, setTouched, validateForm) => {
    const tabFields = getTabFields(tab)

    const validationErrors = await validateForm()

    const errorsInTab = Object.keys(validationErrors).filter((field) => tabFields.includes(field))

    if (errorsInTab.length === 0) {
      setTab(tab + 1)
    } else {
      setTouched(
        tabFields.reduce((acc, field) => {
          acc[field] = true
          return acc
        }, {})
      )
    }
  }

  return (
    <Formik initialValues={initialValues} validationSchema={programSchema} onSubmit={handleSubmit}>
      {({
        values,
        touched,
        validateField,
        setTouched,
        handleChange,
        errors,
        handleBlur,
        handleSubmit,
        setFieldValue,
        validateForm,
      }) => (
        <>
          <div className='card card-custom'>
            <div className='card-header card-header-stretch overflow-auto'>
              <ul
                className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
                role='tablist'
              >
                <li className='nav-item'>
                  <a
                    className={clsx(`nav-link cursor-pointer`, {active: tab === 1})}
                    onClick={() => handleTab(validateField, errors, setTouched, validateForm, 1)}
                    role='tab'
                  >
                    Create Program
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className={clsx(`nav-link cursor-pointer`, {active: tab === 2})}
                    onClick={() => handleTab(validateField, errors, setTouched, validateForm, 2)}
                    role='tab'
                  >
                    Courses
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className={clsx(`nav-link cursor-pointer`, {active: tab === 3})}
                    onClick={() => handleTab(validateField, errors, setTouched, validateForm, 3)}
                    role='tab'
                  >
                    Tags
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className={clsx(`nav-link cursor-pointer`, {active: tab === 4})}
                    onClick={() => handleTab(validateField, errors, setTouched, validateForm, 4)}
                    role='tab'
                  >
                    Preview
                  </a>
                </li>
              </ul>
            </div>

            <form className='form' onSubmit={handleSubmit}>
              <div className='card-body'>
                <div className='tab-content pt-3'>
                  <div className={clsx('tab-pane', {active: tab === 1})}>
                    <Tab1
                      setFieldValue={setFieldValue}
                      errors={errors}
                      touched={touched}
                      values={values}
                      handleChange={handleChange}
                    />
                  </div>

                  <div className={clsx('tab-pane', {active: tab === 2})}>
                    <Tab2
                      setFieldValue={setFieldValue}
                      errors={errors}
                      touched={touched}
                      values={values}
                      handleChange={handleChange}
                    />
                  </div>

                  <div className={clsx('tab-pane', {active: tab === 3})}>
                    <Tab3
                      setFieldValue={setFieldValue}
                      errors={errors}
                      touched={touched}
                      values={values}
                      handleChange={handleChange}
                    />
                  </div>

                  <div className={clsx('tab-pane', {active: tab === 4})}>
                    <Tab4
                      setFieldValue={setFieldValue}
                      errors={errors}
                      touched={touched}
                      values={values}
                      handleChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              {/* end::Body */}
              <div className='d-flex align-items-center justify-content-end my-5'>
                <button
                  type='button'
                  onClick={() => {
                    setTab((prev) => prev - 1)
                    validateForm()
                  }}
                  disabled={tab === 1}
                  className='btn btn-primary ms-2 mt-2 me-2'
                >
                  Back
                </button>

                {tab <= 3 && (
                  <button
                    type='button'
                    onClick={() => handleNextTab(validateField, errors, setTouched, validateForm)}
                    className='btn btn-primary ms-2 mt-2 me-2'
                  >
                    Next
                  </button>
                )}

                {tab === 4 && (
                  <button
                    type='button' // Prevent default form submission
                    className='btn btn-primary ms-2 mt-2 me-2'
                    onClick={() => {
                      if (values.isClone) {
                        document.querySelector('form')?.requestSubmit()
                      } else if (values?.isEdit) {
                        setIsOpen(true) // Open the confirmation modal
                      } else {
                        document.querySelector('form')?.requestSubmit() // Directly submit in create mode
                      }
                    }}
                  >
                    {values.isClone ? 'Clone' : values?.isEdit ? 'Update' : 'Create'}
                  </button>
                )}
              </div>
            </form>

            {/* end::Form */}
          </div>
          <AssignConfirmation
            isVisible={isOpen}
            message='Are you sure you want to update this Program?'
            onConfirm={() => {
              setIsOpen(false)
              setTimeout(() => {
                document.querySelector('form')?.requestSubmit() // Submit the form after modal confirmation
              }, 0)
            }}
            onCancel={() => setIsOpen(false)}
          />
        </>
      )}
    </Formik>
  )
}

export default AddProgram
